<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-1/12 py-2 px-2 font-bold">Сорт.</div>
            <div class="w-6/12 py-2 px-2 font-bold">Опрос</div>
            <div class="w-1/12 py-2 font-bold">Активен</div>
        </div>

        <div
            v-for="item in list"
            :key="item.id"
            class="flex items-center h-10 py-4 border-t border-gray-300"
        >
            <div class="w-1/12 px-2">
                {{ item.sort }}
            </div>

            <div class="w-6/12 truncate px-2">
                <span
                    class="text-purple-700 cursor-pointer hover:underline"
                    @click="$emit('select', item.id)"
                >
                    {{ item.title }}
                </span>
            </div>

            <div class="w-1/12">
                <CBadge :color="item.enabled ? 'success' : 'secondary'">
                    {{ item.enabled ? "Да" : "Нет" }}
                </CBadge>
            </div>
        </div>
    </div>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {
        components: {},

        props: {
            list: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({}),

        computed: {},

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
        },
    };
</script>
